/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */

import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Box, Container, Grid, Card, Switch, CardHeader } from '@mui/material';
import { useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import axiosInstance from '../../utils/axiosInstance';
import SingleSelector from '../single-selector/singleSelector';
import VideoPlayer from '../video-player/videoPlayer';
import {
  FPS_OPTIONS,
  INTERFACE_OPTIONS,
  CLIENT_BITRATE_OPTIONS,
  FRAME_SIZE_OPTIONS,
  FIR_PLI_NACK_OPTIONS,
  QUALITY_LIMITATION_OPTIONS,
} from './debug-graph-options/debugGraphOptions';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" sx={{ display: value === index ? 'inline' : 'none' }}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function StreamStats() {
  const { adaptorType } = window;
  const [camera, setCamera] = useState(null);
  const fpsGraphData = useRef([]);
  const interfaceBandwidthGraphData = useRef([]);
  const [refreshGraphs, setRefreshGraphs] = useState(false);
  const [webrtcReportVideo, setWebrtcReportVideo] = useState(null);
  const [webrtcReportAudio, setWebrtcReportAudio] = useState(null);
  const intervalRef = useRef();
  const prevDate = useRef();
  const clientBitrateGraphData = useRef([]);
  const prevBytesReceived = useRef();
  const frameSizeGraphData = useRef([]);
  const firPliNackGraphData = useRef([]);
  const qualityLimitationGraphData = useRef([]);
  const cameraList = useSelector((state) => state.app.cameraList);

  useEffect(
    () => () => {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
    },
    []
  );

  const fetchData = () => {
    const currDate = new Date().getTime();
    axiosInstance
      .get(
        `${window.location.protocol}//${window.peerConnectionOutboundHost}/api/v1/live/stream/stats?peerId=${window.peerConnectionOutboundId}`
      )
      .then((response) => {
        const { data } = response;
        if (data) {
          console.log('data', data);
          /**
           * FPS data, VST fps and Camera fps
           */
          if (Object.prototype.hasOwnProperty.call(data['streamStats'], 'currentFrameRate')) {
            let f = 0;
            for (let i = 0; i < fpsGraphData.current.length; i += 1) {
              if (fpsGraphData.current[i].name === 'vstFps') {
                f = 1;
                fpsGraphData.current[i].data.push([currDate, Number(data['streamStats']['currentFrameRate'])]);
              }
            }
            if (f === 0) {
              fpsGraphData.current.push({
                name: 'vstFps',
                data: [[currDate, Number(data['streamStats']['currentFrameRate'])]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data['streamSettings'], 'framerate')) {
            let f = 0;
            for (let i = 0; i < fpsGraphData.current.length; i += 1) {
              if (fpsGraphData.current[i].name === 'cameraFps') {
                f = 1;
                fpsGraphData.current[i].data.push([currDate, Number(data['streamSettings'].framerate)]);
              }
            }
            if (f === 0) {
              fpsGraphData.current.push({
                name: 'cameraFps',
                data: [[currDate, Number(data['streamSettings'].framerate)]],
              });
            }
          }
          ApexCharts.exec('fpsGraph', 'updateOptions', {
            series: fpsGraphData.current,
          });

          /**
           * Interface bandwidth
           */
          if (Object.prototype.hasOwnProperty.call(data, 'networkBandwidth') && data.networkBandwidth.length > 1) {
            const interfaces = data.networkBandwidth[0];
            for (const curr_interface of Object.keys(interfaces)) {
              {
                let graph_present = 0;
                let graph_name = curr_interface + "_rx_kbps";
                let f = 0;
                for (let i = 0; i < interfaceBandwidthGraphData.current.length; i += 1) {
                  if (interfaceBandwidthGraphData.current[i].name === graph_name) {
                    graph_present = 1;
                    interfaceBandwidthGraphData.current[i].data.push([
                      currDate,
                      Number(interfaces[curr_interface].rx_kbps),
                    ]);
                  }
                }
                if (graph_present === 0) {
                  interfaceBandwidthGraphData.current.push({
                    name: graph_name,
                    data: [[currDate, Number(interfaces[curr_interface].rx_kbps)]],
                  });
                }
              }
              {
                let graph_present = 0;
                let graph_name = curr_interface + "_tx_kbps";
                for (let i = 0; i < interfaceBandwidthGraphData.current.length; i += 1) {
                  if (interfaceBandwidthGraphData.current[i].name === graph_name) {
                    graph_present = 1;
                    interfaceBandwidthGraphData.current[i].data.push([
                      currDate,
                      Number(interfaces[curr_interface].tx_kbps),
                    ]);
                  }
                }
                if (graph_present === 0) {
                  interfaceBandwidthGraphData.current.push({
                    name: graph_name,
                    data: [[currDate, Number(interfaces[curr_interface].tx_kbps)]],
                  });
                }
              }
              ApexCharts.exec('ethGraph', 'updateOptions', {
                series: interfaceBandwidthGraphData.current,
              });
            }
          }
          /**
           * Quality limitation reason
           */
          if (
            Object.prototype.hasOwnProperty.call(data['streamStats'], 'encode') &&
            data['streamStats'].Encode != null &&
            Object.prototype.hasOwnProperty.call(data['streamStats'].Encode, 'qualityLimitationReason')
          ) {
            let reason = data['streamStats'].Encode.qualityLimitationReason;
            if (reason === 'none') {
              reason = 0;
            } else if (reason === 'cpu') {
              reason = 1;
            } else if (reason === 'bandwidth') {
              reason = 2;
            } else {
              reason = 4;
            }
            let f = 0;
            for (let i = 0; i < qualityLimitationGraphData.current.length; i += 1) {
              if (qualityLimitationGraphData.current[i].name === 'qualityLimitationReason') {
                f = 1;
                qualityLimitationGraphData.current[i].data.push([currDate, reason]);
              }
            }
            if (f === 0) {
              qualityLimitationGraphData.current.push({
                name: 'qualityLimitationReason',
                data: [[currDate, reason]],
              });
            }
            ApexCharts.exec('qualityLimitation', 'updateOptions', {
              series: qualityLimitationGraphData.current,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });

    /**
     * WEBRTC stats
     */
    if (window.peerConnectionOutbound) {
      window.peerConnectionOutbound.getStats(null).then((stats) => {
        stats.forEach((report) => {
          /**
           * video report
           */
          if (report.type === 'inbound-rtp' && report.kind === 'video') {
            setWebrtcReportVideo(report);
            /**
             * client fps
             */
            if (Object.prototype.hasOwnProperty.call(report, 'framesPerSecond')) {
              let f = 0;
              for (let i = 0; i < fpsGraphData.current.length; i += 1) {
                if (fpsGraphData.current[i].name === 'clientFps') {
                  f = 1;
                  fpsGraphData.current[i].data.push([currDate, Number(report.framesPerSecond)]);
                }
              }
              if (f === 0) {
                fpsGraphData.current.push({
                  name: 'clientFps',
                  data: [[currDate, Number(report.framesPerSecond)]],
                });
              }
            }
            /**
             * bitrate calculation
             */
            if (Object.prototype.hasOwnProperty.call(report, 'bytesReceived')) {
              const currBytesReceived = Number(report.bytesReceived) / 1000;
              if (prevDate.current) {
                const clientBitrate = Number(
                  (
                    (8 * (currBytesReceived - prevBytesReceived.current)) /
                    (currDate / 1000 - prevDate.current / 1000)
                  ).toFixed(4)
                );
                {
                  let f = 0;
                  for (let i = 0; i < clientBitrateGraphData.current.length; i += 1) {
                    if (clientBitrateGraphData.current[i].name === 'clientBitrate') {
                      f = 1;
                      clientBitrateGraphData.current[i].data.push([currDate, clientBitrate]);
                    }
                  }
                  if (f === 0) {
                    clientBitrateGraphData.current.push({
                      name: 'clientBitrate',
                      data: [[currDate, clientBitrate]],
                    });
                  }
                }
              }
              prevDate.current = currDate;
              prevBytesReceived.current = currBytesReceived;
              ApexCharts.exec('clientBitrateGraph', 'updateOptions', {
                series: clientBitrateGraphData.current,
              });
            }
            /**
             * frame size calculation
             */
            if (Object.prototype.hasOwnProperty.call(report, 'frameHeight')) {
              let f = 0;
              for (let i = 0; i < frameSizeGraphData.current.length; i += 1) {
                if (frameSizeGraphData.current[i].name === 'frameSize') {
                  f = 1;
                  frameSizeGraphData.current[i].data.push([currDate, Number(report.frameHeight)]);
                }
              }
              if (f === 0) {
                frameSizeGraphData.current.push({
                  name: 'frameSize',
                  data: [[currDate, Number(report.frameHeight)]],
                });
              }
              ApexCharts.exec('frameSize', 'updateOptions', {
                series: frameSizeGraphData.current,
              });
            }
          }
          /**
           * fir pli and nack count
           */
          if (Object.prototype.hasOwnProperty.call(report, 'firCount')) {
            let f = 0;
            for (let i = 0; i < firPliNackGraphData.current.length; i += 1) {
              if (firPliNackGraphData.current[i].name === 'firCount') {
                f = 1;
                firPliNackGraphData.current[i].data.push([currDate, Number(report.firCount)]);
              }
            }
            if (f === 0) {
              firPliNackGraphData.current.push({
                name: 'firCount',
                data: [[currDate, Number(report.firCount)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(report, 'pliCount')) {
            let f = 0;
            for (let i = 0; i < firPliNackGraphData.current.length; i += 1) {
              if (firPliNackGraphData.current[i].name === 'pliCount') {
                f = 1;
                firPliNackGraphData.current[i].data.push([currDate, Number(report.pliCount)]);
              }
            }
            if (f === 0) {
              firPliNackGraphData.current.push({
                name: 'pliCount',
                data: [[currDate, Number(report.pliCount)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(report, 'nackCount')) {
            let f = 0;
            for (let i = 0; i < firPliNackGraphData.current.length; i += 1) {
              if (firPliNackGraphData.current[i].name === 'nackCount') {
                f = 1;
                firPliNackGraphData.current[i].data.push([currDate, Number(report.nackCount)]);
              }
            }
            if (f === 0) {
              firPliNackGraphData.current.push({
                name: 'nackCount',
                data: [[currDate, Number(report.nackCount)]],
              });
            }
            ApexCharts.exec('firPliNack', 'updateOptions', {
              series: firPliNackGraphData.current,
            });
          }
          /**
           * audio report
           */
          if (report.type === 'inbound-rtp' && report.kind === 'audio') {
            setWebrtcReportAudio(report);
          }
        });
      });
    }
  };

  const dataFetcher = () => {
    intervalRef.current = setInterval(() => {
      fetchData();
    }, 5000);
  };

  const cleanup = () => {
    /**
     * clean arrays
     */
    fpsGraphData.current = [];
    interfaceBandwidthGraphData.current = [];
    clientBitrateGraphData.current = [];
    frameSizeGraphData.current = [];
    qualityLimitationGraphData.current = [];
    firPliNackGraphData.current = [];
    setWebrtcReportAudio(null);
    setWebrtcReportVideo(null);

    ApexCharts.exec('fpsGraph', 'updateOptions', {
      series: fpsGraphData.current,
    });
    ApexCharts.exec('ethGraph', 'updateOptions', {
      series: interfaceBandwidthGraphData.current,
    });
    ApexCharts.exec('clientBitrateGraph', 'updateOptions', {
      series: clientBitrateGraphData.current,
    });
    ApexCharts.exec('frameSize', 'updateOptions', {
      series: frameSizeGraphData.current,
    });
    ApexCharts.exec('firPliNack', 'updateOptions', {
      series: firPliNackGraphData.current,
    });
    ApexCharts.exec('qualityLimitation', 'updateOptions', {
      series: qualityLimitationGraphData.current,
    });
  };

  /**
   * clean graphs
   */
  const handleCameraSelect = (cam) => {
    cleanup();
    setCamera(cam);
    if (cam) {
      setRefreshGraphs(true);
      dataFetcher();
    } else {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
      setRefreshGraphs(false);
    }
  };

  const handleRefreshGraphs = () => {
    if (!refreshGraphs) {
      dataFetcher();
    } else {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
    }
    setRefreshGraphs(!refreshGraphs);
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" sx={{ mb: 5 }}>
        Outbound stats
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ p: 3 }}>
              <Stack spacing={3} sx={{ mb: 2 }}>
                <SingleSelector
                  id="outbound-stats"
                  placeholder="Type to search"
                  label={`Select ${adaptorType === "streamer" ? "file" : "camera"}`}
                  value={camera}
                  onChange={handleCameraSelect}
                  getOptionLabel={(option) => {
                    if (option.remoteDeviceName && option.remoteDeviceLocation) {
                      return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                    } if (option.remoteDeviceName) {
                      return `${option.name} at ${option.remoteDeviceName}`;
                    }
                    return option.name;

                  }}
                  options={cameraList}
                />
              </Stack>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          {camera && (
            <VideoPlayer
              camera={camera}
              key={`${camera.sensorId + camera.host + camera.name}_vid_config`}
              page="outbound-stats"
            />
          )}
          {!camera && (
            <Card sx={{ height: 400 }}>
              <CardHeader title={'Select camera'} subheader={'Select camera to show preview'} />
            </Card>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Card>
            <CardHeader title={'Webrtc video stats'} subheader={'inbound-rtp video stats dump'} />
            <Box sx={{ p: 3, height: 330, overflow: 'auto' }}>
              {webrtcReportVideo != null &&
                Object.keys(webrtcReportVideo).map((item) => (
                  <tr key={item} style={{ textAlign: 'left' }}>
                    <td style={{ fontSize: 10 }}>
                      <b>{item}</b>
                    </td>
                    <td style={{ fontSize: 10 }}>{webrtcReportVideo[item]}</td>
                  </tr>
                ))}
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Card>
            <CardHeader title={'Webrtc audio stats'} subheader={'inbound-rtp audio stats dump'} />
            <Box sx={{ p: 3, height: 330, overflow: 'auto' }}>
              {webrtcReportAudio != null &&
                Object.keys(webrtcReportAudio).map((item) => (
                  <tr key={item} style={{ textAlign: 'left' }}>
                    <td style={{ fontSize: 10 }}>
                      <b>{item}</b>
                    </td>
                    <td style={{ fontSize: 10 }}>{webrtcReportAudio[item]}</td>
                  </tr>
                ))}
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Box sx={{ p: 3 }}>
            <Stack direction="row" alignItems="center">
              <Typography>Off</Typography>
              <Switch checked={refreshGraphs} onChange={handleRefreshGraphs} />
              <Typography>On</Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={FPS_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <ReactApexChart type="area" height={350} series={[]} options={CLIENT_BITRATE_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={FRAME_SIZE_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={QUALITY_LIMITATION_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={FIR_PLI_NACK_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={INTERFACE_OPTIONS} />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
